/**
 * Pre-selectează a DOUA variantă (a doua valoare de opțiune) pe pagina de produs,
 * dacă produsul are o singură opțiune (ex. "Volum") cu cel puțin 2 valori și
 * URL-ul nu conține deja ?variant=. Declanșează 'change' ca tema să actualizeze
 * preț / imagine / buton. Produsele cu o singură variantă nu sunt afectate.
 */
(function () {
  function preselect(vs) {
    if (vs.dataset.secondPreselected || vs.hasAttribute('data-keep-first-variant')) return;

    // grupuri de opțiuni în acest picker (button/swatch = fieldset, dropdown = select)
    const fieldsets = vs.querySelectorAll('fieldset');
    const selects = vs.querySelectorAll('select');
    const groupCount = (fieldsets.length || 0) + (selects.length || 0);
    if (groupCount !== 1) return; // acționăm doar la o singură opțiune

    if (fieldsets.length === 1) {
      const radios = Array.from(fieldsets[0].querySelectorAll('input[type="radio"]'));
      if (radios.length < 2) return;
      const second = radios[1];
      if (second.disabled || second.checked) return;
      vs.dataset.secondPreselected = '1';
      second.checked = true;
      second.dispatchEvent(new Event('change', { bubbles: true }));
    } else if (selects.length === 1) {
      const select = selects[0];
      if (select.options.length < 2 || select.selectedIndex === 1) return;
      vs.dataset.secondPreselected = '1';
      select.selectedIndex = 1;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function run() {
    if (new URLSearchParams(window.location.search).has('variant')) return;
    document.querySelectorAll('variant-selects').forEach(preselect);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => requestAnimationFrame(run));
  } else {
    requestAnimationFrame(run);
  }
})();
